/**
 * @file  src\mobile\components\RangeSliderMobile.js
 * @brief  This file is responsible for price slider component
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

const RangeSliderMobile = (props) => {
  const {
    min,
    max,
    value,
    onInput,
    defaultValue,
    onThumbDragStart,
    sliderClass,
    stepValue = 0,
    rangeSlideDisabled,
    thumbsDisabled,
  } = props;

  return (
    <RangeSlider
      className={sliderClass}
      min={min}
      max={max}
      value={value}
      onInput={onInput}
      step={stepValue}
      defaultValue={defaultValue}
      onThumbDragStart={onThumbDragStart}
      thumbsDisabled={thumbsDisabled}
      rangeSlideDisabled={rangeSlideDisabled}
    />
  );
};
export default RangeSliderMobile;
